export interface DependencyStackItem {
	name: string;
	deps: DependencyStackItem[];
}

export const resolveCacheDependenciesArr = (stack: DependencyStackItem) => {
	const set = new Set<string>();

	set.add(stack.name);

	// Extract the first level
	stack.deps.forEach((dep) => {
		set.add(dep.name);
	});

	// Now process the dependencies
	stack.deps.forEach((dep) => {
		resolveCacheDependenciesArr(dep).forEach((val) => {
			return set.add(val);
		});
	});

	return Array.from(set);
};
